module.exports = __webpack_public_path__ + "static/media/medicationsIcon.45b21cb2.png";